import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { SafeHtmlPipe } from '../../../../sb-tools/typescript/pipes/safe-html.pipe';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SafeHtmlPipe],
})
export class ConfirmationModalComponent implements OnDestroy {
    confirmCallback;
    confirmText;
    content;
    declineText;
    onClose: Subject<boolean> = new Subject();
    title;

    constructor(private modalRef: BsModalRef) {}

    confirm(): void {
        this.onClose.next(true);
        this.onClose.complete();

        if (this.confirmCallback) {
            this.confirmCallback();
        }

        this.modalRef.hide();
    }

    decline(): void {
        this.modalRef.hide();
    }

    ngOnDestroy() {
        this.onClose.next(false);
        this.onClose.complete();
    }
}
